<script>

import {mapState} from 'vuex';
/**
 * Dashboard Component
 */
export default {

  computed: {
    ...mapState("authapi", ["user"]),
  },

 created(){
      if( this.user.admin==true){
        this.$router.push({
          name:"admin-dashboard"
        })
      }else{
          this.$router.push({
          name:"member-dashboard"
        })
      }
 }
};
</script>
<template>
<div>Đang chuyển hướng...</div>
</template>